import { PodpisPredseduApi } from 'elegislativa-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';

const client = new PodpisPredseduApi(apiConfiguration(elegislativaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const savePodpisPredseduClient = async (
  type: string,
  year: number,
  index: number,
  pracovnyKrokId: Uuid,
  file: File,
  headers?: object,
):
  Promise<ClientResponse<void>> => {
  const { status } = await client.savePodpisPredsedu(type, year, index, pracovnyKrokId, file, headers);
  return { responseCode: status };
};
